"use client"

import { useEffect } from "react"
import { useNotificationCategoryStore } from "../store/CategoryStore"

interface UseCategorySelectSyncProps {
  instanceId: string
  categoryId?: number
  onChange: (value: { categoryId: number; categoryName: string; slug?: string } | undefined) => void
}

export const useCategorySelectSync = ({ instanceId, categoryId, onChange }: UseCategorySelectSyncProps) => {
  const setCategoryId = useNotificationCategoryStore(state => state.setCategoryId)

  // Sync props.value?.categoryId vào store khi props thay đổi
  useEffect(() => {
    if (categoryId) {
      setCategoryId(instanceId, categoryId)
    }
  }, [categoryId, instanceId, setCategoryId])

  // Handle change từ CategorySelect
  const handleChange = (value: { categoryId: number; categoryName: string; slug?: string } | undefined) => {
    if (value?.categoryId) {
      setCategoryId(instanceId, value.categoryId)
    } else {
      setCategoryId(instanceId, null)
    }
    onChange(value)
  }

  return {
    handleChange,
  }
}
